import React, {Component} from 'react';
import axios from 'axios';
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faEdit, faTrash} from "@fortawesome/free-solid-svg-icons";
import Swal from 'sweetalert2';
import {Link} from 'react-router-dom';
import Spinner from 'react-bootstrap/Spinner';
import 'bootstrap/dist/css/bootstrap.min.css';

export default class EntrepreneurshipList extends Component{
    state = {
        works:[]
    }
    componentDidMount(){
        axios.get('https://arianaapp.arianaapply.com/panel/list-entrepreneurship')
        .then(res=>{
            console.log(res)
            this.setState({works: res.data})
        }).catch(err=>{
            console.log(err)
        })
    }
    deleteHandler(id){
        axios.get(`https://arianaapp.arianaapply.com/panel/delete-entrepreneurship/${id}`)
        .then(res=>{
            console.log(res)
            Swal.fire({
                title: 'با موفقیت حذف شد',
                icon: 'success'
            })

        }).catch(err=>{
            console.log(err)
        })
    }

    render(){
        return(
            <div className="index">
              {
                this.state.works.length > 0 ?
                <div className="table">
                <table>
                  <thead>
                    <tr>
                      <td>دسته بندی</td>
                      <td>شهر</td>
                      <td>عملیات</td>
                    </tr>
                  </thead>
                  <tbody>
                      {
                          this.state.works.map(item=>(
                              <tr key={item._id}>
                              <td>{item.category}</td>
                              <td>{item.city}</td>
                              <td>
                                <div className="d-flex">
                                  <Link to={`/entrepreneurship-edit/${item._id}`}>
                                  <button className="success">
                                    <FontAwesomeIcon icon={faEdit} />
                                  </button>
                                  </Link>
                            
                                  <button className="danger" onClick={()=> this.deleteHandler(item._id)} >
                                    <FontAwesomeIcon icon={faTrash} />
                                  </button>
                                </div>
                              </td>
                            </tr>
                          ))
                          
                      }
      
                  </tbody>
                </table>
              </div> : <Spinner animation="border" variant="primary" />
              }
          </div>
        )
    }
}